import { render, staticRenderFns } from "./AllHouseProduct.vue?vue&type=template&id=66df5eac&scoped=true&"
import script from "./AllHouseProduct.vue?vue&type=script&lang=js&"
export * from "./AllHouseProduct.vue?vue&type=script&lang=js&"
import style0 from "./AllHouseProduct.vue?vue&type=style&index=0&id=66df5eac&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66df5eac",
  null
  
)

component.options.__file = "AllHouseProduct.vue"
export default component.exports